import axios from 'axios';
import moment from 'moment';
import apiConfig from 'src/api/APIConfig';
import config from 'src/appConfig';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { getPoratlHost } from 'src/components/common/hooks/useUtils';
import { store } from 'src/store';
const etmfInstance = axios.create({ baseURL: `${config.appConfig.apietmf}` });
type Callback = (progress: number) => void;

/**
 *
 */
class DocManagementService {
  /**
   *
   * @param file
   */

  async fileUpload(
    file: any,
    progressUpload: Callback,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    const formData = new FormData();
    formData.append('file', file);
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/fileMaster/uploadFile?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        formData,
        headerConfig
      );

      return { data: response, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getArtifactsList(tmfLevel: any, study = '--', country = '--', site = '--', params: any) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/tmfLevel/${tmfLevel}/select?application=ETMF&${type}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getQCDetails(params: any, id: any, tmfDocStudy: any, site: any, country: any, tmfLevel: string) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/qualityControl/${id}/select?application=ETMF&country_id=${country}&site_id=${site}&study_id=${tmfDocStudy}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async CreateQC(params: any, data: any, tmfLevel: any, study: string, country: string, site: string) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/qualityControl/create?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}&tmf_doc_level=${tmfLevel}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updateQC(params: any, docData: any, tmfLevel: any, study: string, country: string, site: string) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/qualityControl/update?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}&tmf_doc_level=${tmfLevel}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getArtifactNameResponse(
    tmfDocLevel: any,
    artifactName: any,
    study = '--',
    country = '--',
    site = '--',
    params: any
  ) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/tmfLevel/docInfo/${tmfDocLevel}/select?application=ETMF&tmf_artifact_name=${artifactName}&${type}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getDocumentDetails(
    data: any,
    country: any,
    site: any,
    tmfDocStudy: any,
    is_scope: boolean,
    tmfLevel: string,
    params: any
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/masterDocument/advanceSearch/select?application=ETMF&country_id=${country}&site_id=${site}&study_id=${tmfDocStudy}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&is_scope=${is_scope}&from=0&size=-1&sort_by=created_on&sort_order=asc`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getVersionHistory(tmfDocId: any, study: string, country: string, site: string, tmfLevel: string, params: any) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/versionHistory?application=ETMF&tmf_document_id=${tmfDocId}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getVesionBasedDocumentDetails(
    tmfDocStudy: any,
    site: any,
    country: any,
    tmfDocId: any,
    version: any,
    tmfLevel: string,
    params: any
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/${tmfDocStudy}/select?application=ETMF&site_id=${site}&country_id=${country}&tmf_document_id=${tmfDocId}&tmf_doc_version_number=${version}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentdetails(
    tmfDocStudy: any,
    tmfDocId: any,
    version: any,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (country != '--' && site == '--' && country !== null) {
      type = `tmf_doc_country=${country}`;
    } else if (site != '--' && site !== null) {
      type = `tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/${tmfDocStudy}/select?application=ETMF&tmf_document_id=${tmfDocId}&tmf_doc_version_number=${version}&${type}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentAuditdetails(tmfDocStudy: any, country: string, site: string, tmfLevel: string, params: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/${tmfDocStudy}/select?application=ETMF&country_id=${country}&site_id=${site}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSubArtifactVersionDetails(
    tmfLevel: any,
    study: string,
    country: string,
    site: string,
    tmfArtifactName: any,
    params: any
  ) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `?tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `?tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `?tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/subArtifact/versions${type}&application=ETMF&tmf_doc_level=${tmfLevel}&tmf_artifact_name=${tmfArtifactName}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async createMasterDocument(params: any, docData: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/masterDocument/create?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updateMasterDocument(params: any, docData: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/masterDocument/inlineUpdate?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error };
    }
  }

  async getMasterDocumentAllSession(
    tmfLevel: string,
    study: string,
    country: string,
    site: string,
    params: any,
    binder: boolean
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/getAll?application=ETMF&tmf_doc_level=${tmfLevel}&is_binder_view=${binder}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}&limit=50`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentArtifactBased(
    binder: boolean,
    artifactNumber: string,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/getAll?application=ETMF&tmf_doc_level=${tmfLevel}&is_binder_view=${binder}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_artifact_number=${artifactNumber}&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentsByUser(
    binder: boolean,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any,
    originally_uploaded: boolean,
    from = -1,
    size = -1
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${
          config.appConfig.apietmf
        }/masterDocument/getAll?study_id=${study}&country_id=${country}&site_id=${site}&tmf_doc_level=${tmfLevel}&application=ETMF&is_binder_view=${binder}&module_section_related=${
          params.module_section_related
        }&parent_entity_related=${
          params.parent_entity_related
        }&user_based_details=true&originally_uploaded=${originally_uploaded}${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSiteStudyPersonnel(value: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apictms}/sitestudypersonnel/get/${value}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getStudyAll() {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response = await etmfInstance.get(`${config.appConfig.apictms}/study/getAll`, headerConfig);
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async deleteDocumentDetails(
    fileMasterId: any,
    tmfDocumentId: any,
    deleteDoc: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.patch(
        `${config.appConfig.apietmf}/masterDocument/${fileMasterId}/delete?application=ETMF&tmf_document_id=${tmfDocumentId}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        deleteDoc,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async getAuditDetails(
    fileId: any,
    size: number,
    order: string,
    data: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response = await etmfInstance.post(
        `${config.appConfig.apietmf}/audit/applyFilter/${fileId}/select?application=ETMF&from=0&size=${size}&sort_by=created_on&sort_order=${order}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllUsers(
    study_id: string,
    tmf_doc_level: string,
    tmf_artifact_name: any,
    country_id: string,
    site_id: string
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`,
        user_date_time: moment().format()
      }
    };
    try {
      const response: any = await etmfInstance.get(
        `${apiConfig.appConfig.apiutilsEtmf}/utils/${study_id}/${tmf_doc_level}/${tmf_artifact_name}/users${
          country_id !== null && country_id !== '--' ? `?country=${country_id}` : ''
        }${site_id !== null && site_id !== '--' ? `&site_id=${site_id}` : ''}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllAccessUsers() {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apiSysAdmin}/sysAdmin/etmf-api/users`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getQualityControlDetailsById(
    id: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/qualityControl/${id}/select?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updatedVersionData(params: any, docData: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/masterDocument/update?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSearchResult(
    data: any,
    study: string,
    country: string,
    site: string,
    is_scope: boolean,
    tmfLevel: string,
    params: any,
    from = -1,
    size = -1
  ) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.post(
        `${
          config.appConfig.apietmf
        }/masterDocument/advanceSearch/select?application=ETMF&country_id=${country}&site_id=${site}&study_id=${study}&tmf_doc_level=${tmfLevel}&module_section_related=${
          params.module_section_related
        }&parent_entity_related=${params.parent_entity_related}&is_scope=${is_scope}&sort_by=created_on&sort_order=asc${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getSearchSuggestions(
    searchText: string,
    filter_types: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const body = filter_types;
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/audit/suggestions/${searchText}?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        body,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAnnotations(
    file_master_id: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/fileComment/${file_master_id}/comments/get?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async sendAnnotations(
    file_master_id: any,
    xfdfString: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const data = { comments: xfdfString };
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/fileComment/${file_master_id}/store/comment?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getGlobalSearch(
    searchObj: any,
    study: string | null,
    country: string | null,
    site: string | null,
    tmfLevel: string,
    params: any,
    from = -1,
    size = -1
  ) {
    const isStudy = study === '--' ? false : true;
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const body = searchObj;
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/masterDocument/advanceSearch/select?application=ETMF${
          country !== null && country !== '--' ? `&country_id=${country}` : ''
        }${site !== null && site !== '--' ? `&site_id=${site}` : ''}${
          study !== null && site !== '--' ? `&study_id=${study}` : ''
        }&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${
          params.parent_entity_related
        }&is_scope=${isStudy}${from > -1 ? `&from=${from}` : ''}${size > -1 ? `&size=${size}` : ''}`,
        body,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async createFilterPreset(
    params: any,
    filterData: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/savePreset/create?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        filterData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllFilterPresets(study: string, country: string, site: string, tmfLevel: string, params: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/savePreset/getAll?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getRecentDocumentApi(
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    binder: boolean,
    params: any,
    from = -1,
    size = -1
  ) {
    let type = '';
    if (study !== '' && study !== null && (!country || country === '--') && (!site || site === '--')) {
      type = `study_id=${study}`;
      tmfLevel = 'Study';
    } else if (country !== '' && country !== null && (!site || site === '--')) {
      type = `study_id=${study}&country_id=${country}`;
      tmfLevel = 'Country';
    } else if (site !== '' && site !== null) {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
      tmfLevel = 'Site';
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${
          config.appConfig.apietmf
        }/masterDocument/getAll?${type}&tmf_doc_level=${tmfLevel}&application=ETMF&is_binder_view=${binder}&module_section_related=${
          params.module_section_related
        }&parent_entity_related=${params.parent_entity_related}${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getCodeList(code: string, params: any, study: string, country: string, site: string, tmfLevel: string) {
    try {
      let type = '';
      if (study !== '--' && country === '--' && site === '--') {
        type = `study_id=${study}`;
      } else if (country !== '--' && site === '--') {
        type = `study_id=${study}&country_id=${country}`;
      } else if (site !== '--') {
        type = `study_id=${study}&country_id=${country}&site_id=${site}`;
      }

      const newState = store.getState();
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          site_token: newState.user.user?.siteToken,
          Authorization: `Bearer ${newState.user.user?.sponsorToken}`
        }
      };

      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/codeList/${code}/select?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updatePresetFilter(
    params: any,
    presetData: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/savePreset/update?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        presetData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async deletePresetFilter(
    presetId: any,
    presetData: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.patch(
        `${config.appConfig.apietmf}/savePreset/${presetId}/delete?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}`,
        presetData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllPlanning(level: string, study: string, country: string, site: string, params: any, from = -1, size = -1) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `&tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `&tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `&tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${
          config.appConfig.apietmf
        }/tmfLevel/plan/getAll?application=ETMF&tmf_doc_level=${level}${type}&module_section_related=${
          params.module_section_related
        }&parent_entity_related=${params.parent_entity_related}${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error };
    }
  }

  async sendEmail(
    key: any,
    documentName: any,
    message: any,
    data: any[],
    user: any,
    tmfLevel: any,
    study: string,
    country: string,
    site: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const appName = 'ETMF';
    try {
      const emails = data.map(obj => {
        return {
          user_id: obj?.id,
          user_name: obj?.user_name,
          recipient: obj.email
        };
      });
      const baseUrl = `${getPoratlHost()}?application=${appName}&key=`;
      const reqData = {
        ui_url: baseUrl,
        hashed_uri_key: key,
        user_name: `${user.firstName + ' ' + user.lastName}`,
        subject: documentName,
        body: message,
        sent_by: user.email,
        recipients: emails
      };

      const newState = store.getState();
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          site_token: newState.user.user?.siteToken,
          Authorization: `Bearer ${newState.user.user?.sponsorToken}`
        }
      };

      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/email/send?application=ETMF&tmf_doc_level=${tmfLevel}&${type}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        reqData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updatePlanningField(params: any, data: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/tmfLevel/plan/${data.tmf_level_map_id}/update?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getAllTasks(study: string, country: string, site: string, params: any, from = -1, size = -1) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    const type = `tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/addTask/getAll?application=ETMF&module_section_related=${
          params.module_section_related
        }
      &parent_entity_related=${params.parent_entity_related}&${type}${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async createTask(
    documentId: any,
    params: any,
    docData: any,
    isWorkFlow: boolean,
    study: string,
    country: string,
    site: string
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/addTask/${documentId}/create?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&is_work_flow=${isWorkFlow}&${type}`,
        docData,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updateTask(
    params: any,
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/addTask/${taskId}/update?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getActionName(
    documentId: string,
    userBased: boolean,
    study: string,
    country: string,
    site: string,
    params: any,
    tmfLevel: string,
    isReview: boolean
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/addTask/${documentId}/select?application=ETMF&user_based_action=${userBased}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&${type}&is_sent_for_review=${isReview}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async completeReview(
    params: any,
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/addTask/${taskId}/update?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async RejectReview(
    taskId: string,
    data: any,
    params: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.put(
        `${config.appConfig.apietmf}/addTask/${taskId}/Reject?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&is_work_flow=true&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async completeApproval(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/addTask/approvalWorkflow/${taskId}/updateStatus?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&is_overwrite=false&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async sendToISF(
    taskId: string,
    data: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    module_section_related: string,
    parent_entity_related: string,
    is_overwrite: boolean,
    is_multiple_isf_mapped_data: boolean
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/addTask/approvalWorkflow/${taskId}/updateStatus?module_section_related=${module_section_related}&is_multiple_isf_mapped_data=${is_multiple_isf_mapped_data}&parent_entity_related=${parent_entity_related}&application=ETMF&tmf_doc_level=${tmfLevel}&is_overwrite=${is_overwrite}&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async updateStatus(
    taskId: string,
    data: any,
    params: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    is_overwrite: boolean
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/addTask/approvalWorkflow/${taskId}/updateStatus?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_level=${tmfLevel}&is_overwrite=${is_overwrite}&${type}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  getTmfLevelBy(study: any, country: any, site: any) {
    let TmfLevel =
      (study === '--' || study === '') && (country === '--' || country == '') && (site === '--' || site === '')
        ? '--'
        : (country === '--' || country == '') && (site === '--' || site === '')
        ? 'Study'
        : site === '--' && country != '--'
        ? 'Country'
        : 'Site';
    if (TmfLevel === '--') {
      TmfLevel = 'Study';
    }
    return TmfLevel;
  }

  async getBinderViewerTree(tmfLevel: any, study: string, country: string, site: string, params: any) {
    let type = '';
    if (study != '--' && country == '--' && site == '--') {
      type = `tmf_doc_study=${study}`;
    } else if (country != '--' && site == '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}`;
    } else if (site != '--') {
      type = `tmf_doc_study=${study}&tmf_doc_country=${country}&tmf_doc_site=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/tmfLevel/binderViewer/getAll?application=ETMF&tmf_doc_level=${tmfLevel}&${type}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getRecentDocumentsByUser(study: string, country: string, site: string, tmfLevel: string, params: any) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }

    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/getAll?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}&is_binder_view=true&user_based_details=true&limit=10`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getRecentDocumentsAllSession(tmfLevel = '--', study = '--', country = '--', site = '--', params: any) {
    try {
      let type;
      if (study === '--' && country === '--' && site === '--') {
        type = '';
      } else if (study !== '--' && country === '--' && site === '--') {
        type = `tmf_doc_level=${tmfLevel}&study_id=${study}&`;
      } else if (study !== '--' && country !== '--' && site === '--') {
        type = `tmf_doc_level=${tmfLevel}&study_id=${study}&country_id=${country}&`;
      } else if (study !== '--' && country !== '--' && site !== '--') {
        type = `tmf_doc_level=${tmfLevel}&study_id=${study}&country_id=${country}&site_id=${site}&`;
      } else {
        type = `country_id=${country}&site_id=${site}&study_id=${study}&tmf_doc_level=${tmfLevel}&`;
      }

      const newState = store.getState();
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          site_token: newState.user.user?.siteToken,
          Authorization: `Bearer ${newState.user.user?.sponsorToken}`
        }
      };

      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/getAll?application=ETMF&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&${type}&is_binder_view=false&limit=100`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      return { data: null, error: error.message };
    }
  }

  async getMasterDocumentAllSessiontmfBinderViewer(
    payload: any,
    level: number,
    nodes: any,
    study: string,
    country: string,
    site: string,
    tmfLevel: string,
    params: any
  ) {
    try {
      const tmf_doc_type = payload.documentType;
      const tmf_doc_subtype = payload.documentSubType;
      const tmf_artifact_number = payload.artifactNumber;
      let type = '';
      if (level === 1) {
        type = `tmf_doc_type=${nodes[0]}`;
      } else if (level === 2) {
        type = `tmf_doc_type=${nodes[0]}&tmf_doc_subtype=${nodes[1]}`;
        window.scrollTo(0, 0);
      } else if (level === 3) {
        type = `tmf_doc_type=${nodes[0]}&tmf_doc_subtype=${nodes[1]}&tmf_artifact_number=${nodes[2]}`;
        window.scrollTo(0, 0);
      }

      const newState = store.getState();
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          site_token: newState.user.user?.siteToken,
          Authorization: `Bearer ${newState.user.user?.sponsorToken}`
        }
      };

      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/masterDocument/getAll?application=ETMF&country_id=${country}&site_id=${site}&study_id=${study}&${type}&tmf_doc_level=${tmfLevel}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&is_binder_view=false&limit=100`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getDocument(viewerDoc: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      let response: any;
      if (viewerDoc.study_id === '') {
        response = await etmfInstance.get(
          `${config.appConfig.apietmf}/hashedLink/${viewerDoc.document_id}/getLink`,
          headerConfig
        );
      } else {
        response = await etmfInstance.get(
          `${config.appConfig.apietmf}/masterDocument/${
            viewerDoc?.study_id
          }/select?site_id=--&country_id=--&latest_version_hyperlink=false&${
            viewerDoc?.document_id !== undefined ? `document_id=${viewerDoc?.document_id}` : null
          }`,
          headerConfig
        );
      }
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.response.status };
    }
  }

  async getMilestoneList(
    tmfLevel: any,
    docType: any,
    docSubType: any,
    artifactName: any,
    study: string,
    country: string,
    site: string,
    params: any
  ) {
    let type = '';
    if (study !== '--' && country === '--' && site === '--') {
      type = `study_id=${study}`;
    } else if (country !== '--' && site === '--') {
      type = `study_id=${study}&country_id=${country}`;
    } else if (site !== '--') {
      type = `study_id=${study}&country_id=${country}&site_id=${site}`;
    }
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };

    try {
      const response: any = await etmfInstance.get(
        `${config.appConfig.apietmf}/tmfLevel/landing/${tmfLevel}/getMilestones?application=ETMF&tmf_doc_type=${docType}&tmf_doc_subtype=${docSubType}&tmf_artifact_name=${artifactName}&${type}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async getDocumentStatusRecords(
    tmfLevel: any,
    study: any,
    country: any,
    site: any,
    docType: any,
    docSubType: any,
    artifact: any,
    milestone: any,
    statusList: any,
    owner: any,
    dataSince: any,
    params: any
  ) {
    try {
      let type = '';
      if (country && site) {
        type = `&tmf_doc_country=${country}&tmf_doc_site=${site}`;
      } else if (country) {
        type = `&tmf_doc_country=${country}`;
      } else if (site) {
        type = `&tmf_doc_site=${site}`;
      }
      const newState = store.getState();
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          site_token: newState.user.user?.siteToken,
          Authorization: `Bearer ${newState.user.user?.sponsorToken}`
        }
      };
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/masterDocument/${tmfLevel}/${study}/getStatusMetric?application=ETMF&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}&tmf_doc_type=${docType}&tmf_doc_subtype=${docSubType}&tmf_artifact_name=${artifact}&tmf_doc_milestone=${milestone}&tmf_doc_created_by=${owner}&delta_months=${dataSince}${type}`,
        statusList,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  /**
   * Bharath
   * @param document
   * @returns
   */
  async getDocAccessPermissions(document: any) {
    try {
      let type = '';
      if (document.tmf_doc_level == 'Study') {
        type = `tmf_doc_level=${document.tmf_doc_level}&tmf_doc_status=${document.tmf_doc_status}&document_id=${document.id}`;
      } else if (document.tmf_doc_level == 'Country') {
        type = `tmf_doc_level=${document.tmf_doc_level}&tmf_doc_country=${document.tmf_doc_country}&tmf_doc_status=${document.tmf_doc_status}&document_id=${document.id}`;
      } else if (document.tmf_doc_level == 'Site') {
        type = `tmf_doc_level=${document.tmf_doc_level}&tmf_doc_country=${document.tmf_doc_country}&tmf_doc_site=${document.tmf_doc_site}&tmf_doc_status=${document.tmf_doc_status}&document_id=${document.id}`;
      }

      const newState = store.getState();
      const headerConfig = {
        headers: {
          sponsor: newState.user.user?.sponsor_sponsor_name,
          site_token: newState.user.user?.siteToken,
          Authorization: `Bearer ${newState.user.user?.sponsorToken}`
        }
      };

      const response: any = await etmfInstance.get(
        `${apiConfig.appConfig.apiutilsEtmf}/utils/permissions?application=ETMF&${type}`,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }
  async BulkUpload(overwrite: boolean, module_section_related: string, data: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/etmfToIsf/bulkPush?application=ETMF&module_section_related=${module_section_related}&is_overwrite=${overwrite}`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async TmfLinkArtifacts(data: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/tmfLevel/tmflink/getAll?application=ETMF`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  async VersionBasedDocument(data: any) {
    const newState = store.getState();
    const headerConfig = {
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        site_token: newState.user.user?.siteToken,
        Authorization: `Bearer ${newState.user.user?.sponsorToken}`
      }
    };
    try {
      const response: any = await etmfInstance.post(
        `${config.appConfig.apietmf}/masterDocument/idBasedVersions/getAll?application=ETMF`,
        data,
        headerConfig
      );
      return { data: response?.data, error: null };
    } catch (error: any) {
      updateUserAccessMessage({ status: error.response.status, dispatch: store.dispatch });
      return { data: null, error: error.message };
    }
  }

  /**
   * End
   */
}

export default DocManagementService;
